import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ProjectsGridService } from '../projects-grid/projects-grid.service';
import { helperService } from 'src/app/utils/helper';
import { PayrollTimeReportService } from './payroll-time-report.service';
import { Table } from 'primeng/table';
import { UsersGridService } from '../users-grid/users-grid.service';
import { practiceArea } from 'src/app/utils/taskCatalogData';

@Component({
    selector: 'payroll-time-report',
    templateUrl: './payroll-time-report.component.html',
    styleUrls: ['./payroll-time-report.component.scss'],
    standalone: false
})
export class PayrollTimeReportComponent implements OnInit {

  reportNonSummaryList: any[]=[];
  reportSummaryList: any[]=[];
  selectedUsers:any[]=[];
  allUsers:any[]=[];
  allOrganisations:any[]=[];
  selectedOrgs:any[]=[];
  isSummaryOnly:Boolean=false;
  generateLoader:Boolean=false;
  showSummaryOnly:Boolean=false;
  selectedDates:any;
  submitted:Boolean=false;
  defaultDate:Date=new Date();
  exportColumns:any[]=[]
  nonSummaryCols:any[]=[]
  summaryCols:any[]=[]
  title:any="";
  allMatters: any[] = [];
  selectedMatters: any[] = [];
  isLoading: Boolean = false;
  payrollSubscription: any = null;
  practiceAreas: any[] = [];
  selectedPracticeAreas: any[] = [];
  errorMsg: string = '';

  constructor( private projectService: ProjectsGridService,private helper: helperService,private payrollService:PayrollTimeReportService, private userService: UsersGridService) { }

  ngOnInit(): void {
    this.isLoading=true;

    this.summaryCols = [
      { field: 'userName', header: 'User Name' },
      { field: 'totaltime', header: 'Total Time (HH:MM)' },
      { field: 'totaltimeDecimal', header: 'Total Time (Decimal)' },
    ];
    this.nonSummaryCols= [
      { field: 'orgName', header: 'Organisation Name' },
      { field: 'matterName', header: 'Matter Name' },
      { field: 'projectName', header: 'Project Name'},
      { field: 'projTaskName', header: 'Task Name' },
      { field: 'practiceArea', header: 'Practice Area' },
      { field: 'trDateStr', header: 'Time Record Date' },
      { field: 'trDescription', header: 'Time Record Description' },
      { field: 'userName', header: 'User Name' },
      { field: 'totalProjTime', header: 'Total Project Time (HH:MM)' },
      { field: 'totalProjTimeDecimal', header: 'Total Project Time (Decimal)' },
      { field: 'totaltime', header: 'Total User Time (HH:MM)' },
      { field: 'totaltimeDecimal', header: 'Total User Time (Decimal)' },
      { field: 'totalTaskTime', header: 'Total Task Time (HH:MM)' },
      { field: 'totalTaskTimeDecimal', header: 'Total Task Time (Decimals)' },
      { field: 'loggedTrTime', header: 'Total Time Record Time (HH:MM)' },
      { field: 'loggedTrTimeDecimal', header: 'Total Time Record Time (Decimals)' }
    ];
    // this.exportColumns = this.summaryCols.map(col => ({title: col.header, dataKey: col.field}));

    this.projectService.getAllOrganizations().subscribe(res => {
      this.allOrganisations = res.data;
      this.selectedOrgs=res.data.map((obj:any)=>obj.id);
      this.payrollService.getMattersByOrgId({ "orgIds" : [] }).subscribe(res => {
        this.allMatters = res.data;
        this.selectedMatters = res.data.map((obj: any) => obj.matterId);
        this.isLoading=false;
      })
    })
    this.projectService.getLPCUsersList({
      "roles": ["TK"],
      // "userTypes": ["Internal"]
    }).subscribe(res => {
      this.allUsers = res.data;
      this.selectedUsers=res.data.map((obj:any)=>obj.id);
    })

    this.userService.getPracticeArea().subscribe(res => {
      this.practiceAreas = res.data;
      this.selectedPracticeAreas = res.data.map((obj: any) => obj.description);
    });
  }

  fetchMattersByOrgIds(){
    this.isLoading=true;
    if(this.selectedOrgs && this.selectedOrgs.length > 0){
      this.payrollService.getMattersByOrgId({ "orgIds" : this.selectedOrgs }).subscribe(res => {
        this.allMatters = res.data;
        this.selectedMatters = res.data.map((obj: any) => obj.matterId);
        this.isLoading=false;
      })
    }else{
      this.allMatters = []
      this.selectedMatters = []
      this.isLoading=false;
    }
    
  }


  loadPayrollReportData(){
    this.submitted=true;
    if((!this.selectedDates||this.selectedDates.length==0)||(!this.selectedOrgs||this.selectedOrgs.length==0)||(!this.selectedUsers||this.selectedUsers.length==0) || (!this.selectedPracticeAreas || this.selectedPracticeAreas.length == 0)){
      return
    }
    this.reportSummaryList=[]
    this.reportNonSummaryList=[]
    this.errorMsg = '';
    let payload={
      startDate:this.helper.convertDateToFormattedStr(this.selectedDates[0]),
      endDate:this.helper.convertDateToFormattedStr(this.selectedDates[1]),
      orgIds:this.selectedOrgs.length==this.allOrganisations.length?[]:this.selectedOrgs,
      userIds:this.selectedUsers.length==this.allUsers.length?[]:this.selectedUsers,
      summaryOnly:this.isSummaryOnly,
      matterIds: this.selectedMatters,
      practiceAreas: this.selectedPracticeAreas
    }
    console.log(payload)
    this.generateLoader=true;
    this.isLoading = true;
    if (this.payrollSubscription) 
      this.payrollSubscription.unsubscribe();
    this.payrollSubscription = this.payrollService.getPayrollReports(payload).subscribe(res => {
      this.showSummaryOnly=this.isSummaryOnly
      let userList=[]
      if(res && res.data){
        let list=res.data
        for (let rec of list){
          if(rec.data){
            userList = this.flattenDetailsData(res.data);
          }else{
            rec.totaltimeDecimal=this.helper.convertTimeNumToDecimal(rec.totaltime);
            rec.totaltime=this.helper.convertTimeNumToStr(rec.totaltime);
          }
        }
        if(userList.length>0){
          this.reportNonSummaryList=userList
        }else{
          this.reportSummaryList= list
        }
      }
      this.generateLoader=false;
      this.isLoading = false;
      this.submitted=false;
      this.errorMsg = '';
    }, error => {
      this.generateLoader = false;
      this.isLoading = false;
      this.submitted=false;
      this.errorMsg = 'Something went wrong. Please try again later.';
      this.reportSummaryList = [];
      this.reportNonSummaryList = [];
    });
  }

  exportReport(table:Table){
    const filename = this.showSummaryOnly ? "Payroll Summary Time Report" : "Payroll Detailed Time Report";
    this.exportCSVWithBOM(table, filename);
  }

  exportCSVWithBOM(table: Table, filename: string) {
    // Get CSV data from PrimeNG table
    const csvData = this.getCSVData(table);
    
    // Add UTF-8 BOM
    const BOM = '\uFEFF';
    const csvContent = BOM + csvData;
    
    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename + '.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  private getCSVData(table: Table): string {
    let csv = '';
    
    // Get headers
    const headers: string[] = [];
    if (table.columns) {
      table.columns.forEach((col: any) => {
        if (col.header) {
          headers.push(col.header);
        }
      });
      csv += headers.join(',') + '\n';
    }
    
    // Get data rows
    const data = table.value || [];
    data.forEach((row: any) => {
      const rowData: string[] = [];
      if (table.columns) {
        table.columns.forEach((col: any) => {
          let cellData = '';
          if (col.field) {
            cellData = this.getNestedProperty(row, col.field) || '';
          }
          // Escape commas and quotes in CSV
          cellData = cellData.toString().replace(/"/g, '""');
          if (cellData.includes(',') || cellData.includes('"') || cellData.includes('\n')) {
            cellData = '"' + cellData + '"';
          }
          rowData.push(cellData);
        });
      }
      csv += rowData.join(',') + '\n';
    });
    
    return csv;
  }

  private getNestedProperty(obj: any, path: string): any {
    return path.split('.').reduce((current, prop) => current && current[prop], obj);
  }

  flattenDetailsData(data:any){
    let flatArray:any=[]
    data.forEach((user:any) => {
      user?.data?.forEach((proj: any) => {
        proj?.projTasks?.forEach((task: any) => {
          task?.timeRecords?.forEach((record: any) => {
            flatArray.push({
              orgName: proj.orgName,
              matterName: proj.matterName,
              projectName: proj.projectName,
              userId: user.userId,
              userName: user.userName,
              projTaskId: task.projTaskId,
              projTaskName: task.projTaskName,
              practiceArea: task.practiceArea,
              projTaskFullName: task.projTaskFullName,
              taskCreatedOn: task.taskCreatedOn,
              trId: record.trId,
              trDescription: record.trDescription,
              trDate: new Date(record.trDate),
              trDateStr: record.trDate,
              loggedTrTime: this.helper.convertTimeNumToStr(record.loggedTime),
              loggedTrTimeDecimal: this.helper.convertTimeNumToDecimal(record.loggedTime),
              totalTaskTime: this.helper.convertTimeNumToStr(task.loggedTime),
              totalTaskTimeDecimal: this.helper.convertTimeNumToDecimal(task.loggedTime),
              totalProjTime: this.helper.convertTimeNumToStr(proj.loggedTime),
              totalProjTimeDecimal: this.helper.convertTimeNumToDecimal(proj.loggedTime),
              totaltime: this.helper.convertTimeNumToStr(user.totaltime),
              totaltimeDecimal: this.helper.convertTimeNumToDecimal(user.totaltime)
            });
          });
        });
      });
    });
    return flatArray;
  }

}
